<template>
  <sAlert
    small>
    <i18n path="Tenders.NewTenderStageCreatedTitle"
          tag="span">
      <template #link>
        <router-link
          data-qa="tenderNumber"
          style="color: var(--alert-text-desc) !important;"
          target="_blank"
          :to="{ name: 'tenderitem', params: { id: value.NewTenderId, org: $route.params.org } }">
          #{{ value.NewTenderNumber }}.
        </router-link>
      </template>
    </i18n>
  </sAlert>
</template>
<script>
export default {
  name: 'EventHistoryNewTenderStageCreatedParams',
  props: {
    value: {
      type: Object
    }
  },
}
</script>
